import { colors } from '@mehilainen/mds-tokens';
import { spacing } from '@mehilainen/mds-tokens';
import { timelineItemClasses } from '@mui/lab';
export const getThemeTimeline = (_tokens) => ({
    MuiTimeline: {
        styleOverrides: {
            root: {},
        },
    },
    MuiTimelineContent: {
        styleOverrides: {
            root: {
                color: colors.Gray900,
            },
        },
    },
    MuiTimelineItem: {
        styleOverrides: {
            root: {
                [`&.${timelineItemClasses.missingOppositeContent}`]: {
                    [`&.${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0,
                    },
                },
            },
        },
    },
    MuiTimelineDot: {
        styleOverrides: {
            root: {
                marginTop: spacing[500].px,
                border: 'none',
                boxShadow: 'none',
                padding: spacing[100].px,
            },
        },
    },
    MuiTimelineConnector: {
        styleOverrides: {
            root: {
                backgroundColor: 'transparent',
                borderLeft: `dashed 2px ${colors.Gray400}`,
                boxSizing: 'border-box',
            },
        },
    },
});
